import { Title } from '../../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            
                            Axial Sagital e coronal C/C utilizar ww 350 e wl 40;
                        </p>
                        <p>
                            <b>Axial</b> 3 filmes na formatação de 20 imagens;<br/>
                            <b>Coronal </b> - 1 filme na formatação de 20 imagens;<br/>
                            <b>Sagital </b> - 1 filme na formatação de 20 imagens; <br/>
                        </p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Sagital papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Sagital papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}